import React from 'react';
import { Button } from '../ui/button';

/**
 * Componente de controles de paginación reutilizable
 */
export const Pagination = ({
  currentPage,
  totalPages,
  totalItems,
  startIndex,
  endIndex,
  onPrevPage,
  onNextPage,
  hasPrevPage,
  hasNextPage,
  className = '',
}) => {
  if (totalPages <= 1) return null;

  return (
    <div className={`flex items-center justify-between border-t pt-4 mt-4 ${className}`}>
      <div className="text-sm text-gray-600">
        Página {currentPage} de {totalPages}
        {totalItems && ` (${startIndex} - ${endIndex} de ${totalItems})`}
      </div>
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onPrevPage}
          disabled={!hasPrevPage}
        >
          Anterior
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={onNextPage}
          disabled={!hasNextPage}
        >
          Siguiente
        </Button>
      </div>
    </div>
  );
};

export default Pagination;
